import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export const useUnavailableDates = () => {
  const $ = _c(4);
  const [unavailableDates, setUnavailableDates] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const storedUnavailableDates = sessionStorage.getItem("unavailableDates") ? JSON.parse(sessionStorage.getItem("unavailableDates") || "") : null;
      if (storedUnavailableDates) {
        setUnavailableDates(storedUnavailableDates);
      }
      const listenUpdatedUnavailableDates = () => {
        const updatedUnavailableDates = sessionStorage.getItem("unavailableDates") ? JSON.parse(sessionStorage.getItem("unavailableDates") || "") : null;
        if (updatedUnavailableDates) {
          setUnavailableDates(updatedUnavailableDates);
        }
      };
      window.addEventListener("updatedUnavailableDates", listenUpdatedUnavailableDates);
      return () => window.removeEventListener("updatedUnavailableDates", listenUpdatedUnavailableDates);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== unavailableDates) {
    t2 = [unavailableDates, setUnavailableDates];
    $[2] = unavailableDates;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};